/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { InputGroup, Input, InputGroupText } from 'reactstrap';
import SimpleTooltip from '../../../simple-tooltip';
import UniversalTracker from '../../../../model/UniversalTracker';
import { convertValueByDecimal, getUtrDecimal } from '../../../utr-decimal/utils';
import { HandleValueChange } from './InputProps';
import { TableColumn } from './table/InputInterface';
import { InputHelperText } from './InputHelperText';

export interface ValueSliderProps {
  value?: number | string | string[],
  disabled?: boolean,
  placeholder?: string,
  tooltip?: any,
  handleChange: HandleValueChange,
  min?: number,
  max?: number,
  invalidMessage?: string,
  universalTracker?: Pick<UniversalTracker, 'getValueValidation' | 'getValueType'>,
  column?: Pick<TableColumn, 'code'>;
}

export default function ValueSlider(props: ValueSliderProps) {
  const { value, disabled, placeholder, tooltip, handleChange, min = 0, max = 100, invalidMessage = '', universalTracker, column } = props;

  const onSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const convertedValue = convertValueByDecimal({
      decimal: getUtrDecimal(universalTracker, column?.code),
      value: e.target.value,
    });
    handleChange({ value: convertedValue, min, max });
  }

  return <div className='row'>
    <div className='col-6'>
      <SimpleTooltip text={tooltip}>
        <Input
          type='range'
          className='h-100'
          value={value === undefined || (typeof value === 'number' && isNaN(value)) || value === '' ? 0 : value}
          disabled={!!disabled}
          onChange={onSliderChange}
          invalid={!!invalidMessage}
          min={min}
          max={max} />
      </SimpleTooltip>
    </div>
    <div className='col-6'>
      <InputGroup className='has-validation'>
        <Input
          type='number'
          disabled={!!disabled}
          placeholder={placeholder}
          value={value === undefined || (typeof value === 'number' && isNaN(value)) || value === '' ? '' : value}
          className={`w-50 ${invalidMessage ? '' : 'styled-input'}`}
          invalid={!!invalidMessage}
          min={min}
          max={max}
          onChange={(e) => handleChange({ value: e.target.value, min, max })}
        />
        <InputGroupText className={`w-50 ${invalidMessage ? 'styled-readonly-invalid' : 'styled-readonly'}`}>Percent</InputGroupText>
        <InputHelperText invalidMessage={invalidMessage} universalTracker={universalTracker} inputName={column?.code} />
      </InputGroup>
    </div>
  </div>
}
